import { useDispatch, useSelector } from 'react-redux'

import type { RootState, AppDispatch } from 'store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
